export const FETCH_ASSESMENT_TEST_REQUEST     = "FETCH_ASSESMENT_TEST_REQUEST";
export const FETCH_ASSESMENT_TEST_SUCCESSFUL  = "FETCH_ASSESMENT_TEST_SUCCESSFUL";
export const FETCH_ASSESMENT_TEST_FAILURE     = "FETCH_ASSESMENT_TEST_FAILURE";

export const UPDATE_ASSESMENT_TEST_REQUEST     = "UPDATE_ASSESMENT_TEST_REQUEST";
export const UPDATE_ASSESMENT_TEST_SUCCESSFUL  = "UPDATE_ASSESMENT_TEST_SUCCESSFUL";
export const UPDATE_ASSESMENT_TEST_FAILURE     = "UPDATE_ASSESMENT_TEST_FAILURE";

export const UPDATE_ASSESMENT_TEST_ELAPSED_TIME     = "UPDATE_ASSESMENT_TEST_ELAPSED_TIME";